import axiosInstance from "./global";

import CONFIG from "../../config";
const baseURL = `${CONFIG.BASE_URL}/dispute-service/api/v2/dispute`;
const merchantRaisedComplaintBaseUrl = `${CONFIG.BASE_URL}/dispute-service/api/v2/complaint`

export const createDispute = async ({ dispute }) =>
  await axiosInstance
    .post(`${baseURL}`, dispute)
    .then((res) => res.data)
    .catch((err) => {
      throw new Error(err);
    });

export const fetchDisputeStats = async () =>
  await axiosInstance
    .get(`${baseURL}/report/stats`)
    .then((res) => res.data.data)
    .catch((err) => console.log(err));

export const getDisputeList = async (q) => {
  const Query = { ...q, ORDER: "ASC" };
  const params = new URLSearchParams(Query).toString();
  return await axiosInstance
    .get(`${baseURL}/filter-search?${params}`)
    .then((res) => res.data.data)
    .catch((err) => console.log(err));
};

export const fetchMerchantraisedDisputeStats = async () =>
  await axiosInstance
    .get(`${merchantRaisedComplaintBaseUrl}/stats`)
    .then((res) => res.data.data)
    .catch((err) => console.log(err));

    const disputeComplaintId = localStorage.getItem('merchantRaisedComplaintId');

    export const resolveMerchantRaisedDispute = async ({ status }) =>
      await axiosInstance
        .patch(
          `${merchantRaisedComplaintBaseUrl}/${disputeComplaintId}?disputeStatus=${status}`
        )
        .then((res) => res.data)
        .catch((err) => console.log(err));

export const getMerchantRaisedDisputeList = async (q) => {
  const Query = { ...q, ORDER: "ASC" };
  const params = new URLSearchParams(Query).toString();
  return await axiosInstance
    .get(`${merchantRaisedComplaintBaseUrl}`)
    .then((res) => res.data.data)
    .catch((err) => console.log(err));
};


export const fetchDispute = async (disputeId) =>
  await axiosInstance
    .get(`${baseURL}/fetch/${disputeId}`)
    .then((res) => res.data.data)
    .catch((err) => console.log(err));

export const resolveDispute = async ({ disputeId, status, message }) =>
  await axiosInstance
    .patch(
      `${baseURL}/resolve-dispute/${disputeId}?message=${message}&status=${status}`
    )
    .then((res) => res.data)
    .catch((err) => alert("Merchant needs to respond"));

export const acceptMerchantDispute = async ({
  merchantCustomerDisputeId,
  data,
}) => {
  return await axiosInstance
    .put(`${baseURL}/accept-dispute/${merchantCustomerDisputeId}`, data)
    .then((res) => res.data)
    .catch((err) => alert("Error while responding to dispute"));
};

export const rejectMerchantDispute = async ({
  files,
  merchantRejectionDocumentType,
  disputeRejectReason,
  merchantCustomerDisputeId,
}) => {
  let formData = new FormData();
  formData.append("files", files);
  formData.append(
    "merchantRejectionDocumentType",
    merchantRejectionDocumentType
  );
  formData.append("disputeRejectReason", disputeRejectReason);
  return await axiosInstance
    .post(`${baseURL}/reject-dispute/${merchantCustomerDisputeId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data)
    .catch((err) => alert("Error while responding to disput"));
};
